import { GetBankDetailsByRoutingNumber } from "../reducers/authentication.slice";

export const authenticationApis = {
  registerUser: "v1/auth/register",
  loginUser: "v1/auth/login",
  loginByGoogle: "v1/auth/google_login",
  loginByApple: "v1/auth/apple_login",
  verifyEmail: "v1/auth/verify_email",
  forgotPasswordApi: "v1/auth/send_email_otp",
  resetPasswordApi: "v1/auth/reset_password",
  getDiscordId: "v1/user/discord",
  addManagers: "v1/user/add",
  getUserByid: "v1/user/get_details",
  getListAllUser: "v1/user/list_all",
  verifyManagement: "v1/user/verify_invite",
  uploadProfilePicture: "v1/user/profile_picture",
  updateProfile: "v1/user/profile_update",
  sendMobileOtp: "v1/auth/send_mobile_otp",
  verifyMobileOtp: "v1/auth/verify_mobile",
  updateDiscordRole: "v1/user/add_discord_id",
  verifyGiftCardEmail: "v1/auth/verify_otp",
  getPaymentDetails: "v1/user/get_payment_details",
  addPaymentDetails: "v1/user/add_payment_details",
  makeDefaultMethod: "v1/user/payment_make_default",
  deletePaymentDetails: "v1/user/delete_payment_details",
  GetBankDetailsByRoutingNumber: "v1/user/verify_routing_number",
  enable2FA: "v1/auth/enable-2fa",
  verify2FASetup: "v1/auth/verify-2fa-setup",
  verify2FALogin: "v1/auth/verify-2fa",
  disable2FA: "v1/auth/disable-2fa",
  createPlaidIdentityVerification: "v1/plaid/identity_verification/create",
  retryPlaidIdentityVerification: "v1/plaid/identity_verification/retry",
  getPlaidIdentityVerificationStatus: "v1/plaid/identity_verification/status",
  manualVerifyPlaidIdentity: "v1/plaid/identity_verification/manual_verify",
  createPlaidBankLinkToken: "v1/plaid/bank_verification/link_token",
  getPlaidBankVerificationStatus: "v1/plaid/bank_verification/status",
  verifyPlaidBankAccount: "v1/plaid/bank_verification/verify",
  manualVerifyPlaidBankAccount: "v1/plaid/bank_verification/manual_verify",
};

export const apiKeyApis = {
  createApiKey: "v1/api_key/create",
  listApiKeys: "v1/api_key/list_all",
  updateApiKeyStatus: "v1/api_key/update_status",
};

export const analyticsApis = {
  getMemberAnalytics: "v1/dashboard/member",
  getManagerAnalytics: "v1/dashboard/manager",
  // getAdminAnalytics: "v1/dashboard/admin",
  getTutorialVideo: "v1/faq/tutorial_video",
  createLeadsApi: "v1/lead/create",
  getAllLeadsApi: "v1/lead/list_all",
};

export const quotesApis = {
  createQuote: "v1/quote/create",
  getAllQuotes: "v1/quote/list_all",
  updateQuote: "v1/quote/update",
  updateQuoteStatus: "v1/quote/update_status",
  getQuoteById: "v1/quote",
  getUpcLookup: "v1/quote/upc_lookup",
};

export const prequotedApis = {
  createPreQuotedCooks: "v1/pre_quote/create",
  getAllPreQuotes: "v1/pre_quote/list_all",
  getAllPreQuoteBrands: "v1/pqc_brand/list_all",
  getAllPreQuoteSets: "v1/pqc_set/list_all",
  updatePreQuote: "v1/pre_quote/update",
  updateStatusPreQuotes: "v1/pre_quote/update_status",
  getPreQuoteById: "v1/pre_quote",
  getApprovedQty: "v1/pre_quote/allowed_quantity",
  createPQCBrand: "v1/pqc_brand/create",
  updatePQCBrand: "v1/pqc_brand/update",
  deletePQCBrand: "v1/pqc_brand/delete",
  reorderPQCBrands: "v1/pqc_brand/reorder",
  createPQCSet: "v1/pqc_set/create",
  updatePQCSet: "v1/pqc_set/update",
  deletePQCSet: "v1/pqc_set/delete",
  reorderPQCSets: "v1/pqc_set/reorder",
};

export const InstoreFlipsApis = {
  createInstoreflips: "v1/instore_flip/create",
  getAllInstoreflips: "v1/instore_flip/list_all",
  updateInstoreflips: "v1/instore_flip/update",
  updateStatusInstoreflips: "v1/instore_flip/update_status",
  getInstoreflipsById: "v1/instore_flips",
  getApprovedQtyISF: "v1/instore_flip/allowed_quantity",
};

export const orderApis = {
  createOrder: "v1/order/create",
  getAllOrder: "v1/order/list_all",
  getOrderById: "v1/order",
  getOrderBYItemId: "v1/order_item",
  updateOrderStatus: "v1/order/update_status",
  updateOrderItemStatus: "v1/order_item/update_status",
  getOrderItemListApproved: "v1/order_item/list_approved",
  bulkApprovalOrder: "v1/order/bulk_status_update",
};

export const shipmentApis = {
  createShipment: "v1/shipment/create",
  updateShipment: "v1/shipment/update",
  getAllShipment: "v1/shipment/list_all",
  getShipmentBYItemId: "v1/shipment",
  uploadShipmentDoc: "v1/shipment/upload",
  downloadShipmentDoc: "v1/shipment/download",
  getInvoiceDetails: "v1/shipment/get_invoice_details",
  validateShipmentDetails: "v1/shipment/walmart_shipment_status",
  getTrackingDetailsById: "v1/shipment_tracking",
  updateShipmentTracking: "v1/shipment_tracking/update",
  retryShipmentTracking: "/v1/shipment/retry_shipment_tracking",
  syncShipmentWithWMS: "v1/shipment",
};

export const payoutsApis = {
  getAllPayouts: "v1/payout/list_all",
  getAllWithdrawalRequest: "/v1/withdrawal/list_all",
  getAllWalletTransction: "v1/wallet_transaction/list_all",
  getAllGiftCardRedemption: "v1/redemption_request/list_all",
  downloadPayoutInvoice: "v1/payout/download",
  uploadPayout: "v1/payout/upload",
  updatePayoutDetails: "v1/payout/update",
  updateGiftCardRedemptionDetails: "v1/redemption_request/update",
  uploadBarcodeRedemption: "v1/redemption_request/upload",
  migratePayout: "v1/payout/migrate_data",
  listAllCases: "v1/payout/case/list_all",
  updateCase: "v1/payout/case/update",
  getCaseByid: "v1/payout/case/get_shipment_details",
  downloadPayoutCase: "v1/payout/case/download",
  downloadRedemptionBarcode: "v1/redemption_request/download",
  paypalPaymentApi: "v1/withdrawal/paypal_payment",
};

export const dropShipApis = {
  createDropShip: "v1/ship_direct/create",
  getAllDropShip: "v1/ship_direct/list_all",
  updateDropShip: "v1/ship_direct/update",
  updateStatusDropShip: "v1/ship_direct/update_status",
  getDropShipById: "v1/ship_direct",
  getApprovedQtyDropShip: "v1/ship_direct/allowed_quantity",
};

export const giftCardApis = {
  getAllGiftCards: "v1/giftcard/list_all_grouped",
  getAllGiftCardsManager: "v1/giftcard/list_all",
  createRedemption: "v1/redemption_request/create",
  createWithdrawalRequest: "v1/withdrawal/create",
  updateWithdrawalRequest: "v1/withdrawal/update",
  uploadWithdrawalRequest: "v1/withdrawal/upload",
  createGiftCard: "v1/giftcard/create",
  updateGiftCard: "v1/giftcard/update",
  getInvoiceDetails: "v1/withdrawal/get_invoice_details",
  downloadWithdrawalInvoice: "v1/withdrawal/download",
};

export const walletApis = {
  getWalletSummary: "v1/wallet_transaction/get_summary",
  getAllWalletTransaction: "v1/wallet_transaction/list_all",
};
export const warehouseApis = {
  createInboundShipment: "v1/inbound_shipment/create",
  listAllItemsByTrackingNumber: "v1/inbound_shipment/items_by_tracking",
  listAllTrackingNumbers: "v1/inbound_shipment/list_tracking_numbers",
  getInboundShipmentLogs: "v1/inbound_shipment/logs",
  listAllInventoryItems: "v1/inventory/list_all_items",
  getInventoryLogs: "v1/inventory/get_item_logs",
  uploadInboundShipmentImage: "v1/inbound_shipment/upload",
  downloadInboundShipmentImage: "v1/inbound_shipment/download",
  getShipmentSummary: "v1/inventory/get_shipment_summary",
};


